import { useEffect, useRef, useState } from "react";

const Counter = ({ resendOtpHandler }) => {
  const [counter, setCounter] = useState(55);
  const [showResendLink, setShowResendLink] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => setCounter((prev) => prev - 1), 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (counter === 0 && intervalRef.current) {
      setShowResendLink(true);
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [counter]);

  const handleClick = () => {
    setCounter(55);
    setShowResendLink(false);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    intervalRef.current = setInterval(() => setCounter((prev) => prev - 1), 1000);
    resendOtpHandler();
  };

  return showResendLink ? (
    <p className="text-center code-txt" onClick={handleClick}>
      Resend
    </p>
  ) : (
    <p className="text-center code-txt">You can resend code {counter} s</p>
  );
};

export default Counter;
